/* ============================================
   SMITH'S BLADES — CONTACT PAGE JS
   Professional form validation, input masking,
   anti-spam, FAQ accordion, file upload
   v3 — Removed body_prepend logic
   ============================================ */

(function () {
  'use strict';

  /* ═══════════════════════════════════════
     FORM VALIDATION ENGINE
     ═══════════════════════════════════════ */
  function initFormValidation() {
    var form = document.getElementById('contactForm');
    if (!form) return;

    /* Disable browser native validation */
    form.setAttribute('novalidate', '');

    var submitBtn = form.querySelector('.contact-submit');

    var fieldConfig = {
      name: {
        input: form.querySelector('#contactName'),
        wrapper: form.querySelector('[data-contact-field="name"]'),
        required: true,
        validate: function (v) { return v.trim().length >= 2; },
        filter: function (v) { return v.replace(/[^a-zA-ZÀ-ÿ\s\-\'.]/g, ''); },
        message: 'Please enter your name (at least 2 characters)'
      },
      email: {
        input: form.querySelector('#contactEmail'),
        wrapper: form.querySelector('[data-contact-field="email"]'),
        required: true,
        validate: function (v) {
          return /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+$/.test(v.trim());
        },
        message: 'Please enter a valid email address'
      },
      phone: {
        input: form.querySelector('#contactPhone'),
        wrapper: form.querySelector('[data-contact-field="phone"]'),
        required: false,
        validate: function (v) {
          if (!v.trim()) return true;
          var digitsOnly = v.replace(/[^\d]/g, '');
          return digitsOnly.length >= 7 && digitsOnly.length <= 15;
        },
        filter: function (v) { return v.replace(/[^\d+\-() ]/g, ''); },
        message: 'Please enter a valid phone number (7-15 digits)'
      },
      subject: {
        input: form.querySelector('#contactSubject'),
        wrapper: form.querySelector('[data-contact-field="subject"]'),
        required: true,
        validate: function (v) { return v.trim().length > 0; },
        message: 'Please select a subject'
      },
      order: {
        input: form.querySelector('#contactOrder'),
        wrapper: form.querySelector('[data-contact-field="order"]'),
        required: false,
        validate: function (v) {
          if (!v.trim()) return true;
          return /^#?\d{4,8}$/.test(v.trim());
        },
        filter: function (v) { return v.replace(/[^#\d]/g, ''); },
        message: 'Please enter a valid order number (e.g. #1234)'
      },
      message: {
        input: form.querySelector('#contactMessage'),
        wrapper: form.querySelector('[data-contact-field="message"]'),
        required: true,
        validate: function (v) { return v.trim().length >= 10; },
        message: 'Please enter at least 10 characters'
      }
    };

    /* Input filtering (masks) */
    Object.keys(fieldConfig).forEach(function (key) {
      var field = fieldConfig[key];
      if (!field.input || !field.filter) return;

      field.input.addEventListener('input', function () {
        var filtered = field.filter(this.value);
        if (filtered !== this.value) {
          this.value = filtered;
        }
      });
    });

    /* Real-time validation on blur */
    Object.keys(fieldConfig).forEach(function (key) {
      var field = fieldConfig[key];
      if (!field.input) return;

      field.input.addEventListener('blur', function () {
        validateField(field);
      });

      field.input.addEventListener('input', function () {
        if (field.wrapper && field.wrapper.classList.contains('has-error')) {
          validateField(field);
        }
      });
    });

    /* Form submission */
    form.addEventListener('submit', function (e) {

      /* ANTI-SPAM: Honeypot */
      var honeypot = form.querySelector('#contactHoneypot');
      if (honeypot && honeypot.value) {
        e.preventDefault();
        return;
      }

      /* ANTI-SPAM: Timestamp */
      var timestamp = form.querySelector('#contactTimestamp');
      if (timestamp) {
        var elapsed = Date.now() - parseInt(timestamp.value);
        if (elapsed < 3000) {
          e.preventDefault();
          return;
        }
      }

      /* Validate all fields */
      var isValid = true;
      var firstError = null;

      Object.keys(fieldConfig).forEach(function (key) {
        var field = fieldConfig[key];
        if (!field.input) return;

        if (!validateField(field)) {
          isValid = false;
          if (!firstError) firstError = field.input;
        }
      });

      if (!isValid) {
        e.preventDefault();
        if (firstError) {
          firstError.focus();
          firstError.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
        return;
      }

      /* Disable submit button */
      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.innerHTML = '<i class="ti ti-loader"></i> Sending...';
      }
    });

    function validateField(field) {
      if (!field.input || !field.wrapper) return true;

      var value = field.input.value;

      /* Skip optional empty fields */
      if (!field.required && !value.trim()) {
        field.wrapper.classList.remove('has-error', 'is-valid');
        return true;
      }

      /* Required empty field */
      if (field.required && !value.trim()) {
        field.wrapper.classList.add('has-error');
        field.wrapper.classList.remove('is-valid');
        setFieldError(field, field.message);
        return false;
      }

      /* Validate value */
      if (field.validate(value)) {
        field.wrapper.classList.remove('has-error');
        if (value.trim()) field.wrapper.classList.add('is-valid');
        else field.wrapper.classList.remove('is-valid');
        return true;
      } else {
        field.wrapper.classList.add('has-error');
        field.wrapper.classList.remove('is-valid');
        setFieldError(field, field.message);
        return false;
      }
    }

    function setFieldError(field, message) {
      var errorEl = field.wrapper.querySelector('.contact-field-error');
      if (errorEl && message) {
        errorEl.textContent = message;
      }
    }
  }

  /* ═══════════════════════════════════════
     CHARACTER COUNTER
     ═══════════════════════════════════════ */
  function initCharCounter() {
    var textarea = document.getElementById('contactMessage');
    var counter  = document.getElementById('contactCharCounter');
    if (!textarea || !counter) return;

    var max = parseInt(textarea.getAttribute('maxlength')) || 2000;

    function update() {
      var len = textarea.value.length;
      counter.textContent = len + ' / ' + max;
      counter.classList.remove('is-near-limit', 'is-at-limit');
      if (len >= max) counter.classList.add('is-at-limit');
      else if (len >= max * 0.9) counter.classList.add('is-near-limit');
    }

    textarea.addEventListener('input', update);
    update();
  }

  /* ═══════════════════════════════════════
     FILE UPLOAD
     ═══════════════════════════════════════ */
  function initFileUpload() {
    var dropzone   = document.querySelector('.contact-dropzone');
    var fileInput  = document.getElementById('contactFile');
    var preview    = document.querySelector('.contact-file-preview');
    var removeBtn  = document.querySelector('.contact-file-remove');
    var hiddenRef  = document.getElementById('contactFileRef');
    if (!dropzone || !fileInput) return;

    var maxFileSize  = 5 * 1024 * 1024;
    var allowedTypes = ['image/jpeg', 'image/png', 'image/gif', 'image/webp', 'application/pdf'];

    fileInput.addEventListener('change', handleFileSelect);

    dropzone.addEventListener('dragover', function (e) {
      e.preventDefault();
      dropzone.classList.add('is-dragover');
    });

    dropzone.addEventListener('dragleave', function () {
      dropzone.classList.remove('is-dragover');
    });

    dropzone.addEventListener('drop', function (e) {
      e.preventDefault();
      dropzone.classList.remove('is-dragover');
      if (e.dataTransfer.files.length) {
        fileInput.files = e.dataTransfer.files;
        handleFileSelect();
      }
    });

    if (removeBtn) {
      removeBtn.addEventListener('click', function () {
        fileInput.value = '';
        if (preview) preview.classList.remove('is-visible');
        if (hiddenRef) hiddenRef.value = '';
        dropzone.style.display = '';
      });
    }

    function handleFileSelect() {
      var file = fileInput.files[0];
      if (!file) return;

      if (allowedTypes.indexOf(file.type) === -1) {
        alert('Please select a JPG, PNG, GIF, WebP, or PDF file.');
        fileInput.value = '';
        return;
      }

      if (file.size > maxFileSize) {
        alert('File size must be under 5MB.');
        fileInput.value = '';
        return;
      }

      if (hiddenRef) {
        hiddenRef.value = 'Attachment: ' + file.name + ' (' + formatFileSize(file.size) + ')';
      }

      if (preview) {
        var nameEl  = preview.querySelector('.contact-file-preview-name');
        var sizeEl  = preview.querySelector('.contact-file-preview-size');
        var thumbEl = preview.querySelector('.contact-file-preview-thumb');

        if (nameEl) nameEl.textContent = file.name;
        if (sizeEl) sizeEl.textContent = formatFileSize(file.size);

        if (thumbEl && file.type.indexOf('image') === 0) {
          var reader = new FileReader();
          reader.onload = function (e) {
            thumbEl.innerHTML = '<img src="' + e.target.result + '" alt="Preview">';
          };
          reader.readAsDataURL(file);
        } else if (thumbEl) {
          thumbEl.innerHTML = '<i class="ti ti-file-text"></i>';
        }

        preview.classList.add('is-visible');
        dropzone.style.display = 'none';
      }
    }

    function formatFileSize(bytes) {
      if (bytes < 1024) return bytes + ' B';
      if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(1) + ' KB';
      return (bytes / (1024 * 1024)).toFixed(1) + ' MB';
    }
  }

  /* ═══════════════════════════════════════
     FAQ ACCORDION
     ═══════════════════════════════════════ */
  function initFAQ() {
    var items = document.querySelectorAll('.contact-faq-item');
    if (!items.length) return;

    items.forEach(function (item) {
      var question = item.querySelector('.contact-faq-question');
      var answer   = item.querySelector('.contact-faq-answer');
      if (!question || !answer) return;

      question.addEventListener('click', function () {
        var isOpen = item.classList.contains('is-open');

        items.forEach(function (other) {
          if (other !== item && other.classList.contains('is-open')) {
            other.classList.remove('is-open');
            var otherAnswer = other.querySelector('.contact-faq-answer');
            if (otherAnswer) otherAnswer.style.maxHeight = '0';
          }
        });

        if (isOpen) {
          item.classList.remove('is-open');
          answer.style.maxHeight = '0';
        } else {
          item.classList.add('is-open');
          answer.style.maxHeight = answer.scrollHeight + 'px';
        }
      });
    });
  }

  /* ═══════════════════════════════════════
     SCROLL REVEAL
     ═══════════════════════════════════════ */
  function initReveal() {
    var elements = document.querySelectorAll('.contact-reveal');
    if (!elements.length) return;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });

    elements.forEach(function (el) { observer.observe(el); });
  }

  /* ═══════════════════════════════════════
     SUCCESS SCROLL
     ═══════════════════════════════════════ */
  function initSuccessScroll() {
    var successEl = document.getElementById('contactSuccess');
    if (!successEl) return;
    setTimeout(function () {
      successEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }, 300);
  }

  /* ═══════════════════════════════════════
     INIT
     ═══════════════════════════════════════ */
  function init() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
      return;
    }

    /* Set anti-spam timestamp */
    var tsField = document.getElementById('contactTimestamp');
    if (tsField) tsField.value = Date.now();

    initFormValidation();
    initCharCounter();
    initFileUpload();
    initFAQ();
    initReveal();
    initSuccessScroll();
  }

  init();

})();